import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type {
  AccountGetBuyerApplicationsQuery,
  AccountGetBuyerApplicationsQueryVariables,
} from '@gql/graphql';
import { DogBreederApplicationStatus, SortOrder } from '@gql/graphql';

export const ACCOUNT_GET_BUYER_APPLICATIONS = graphql(`
  query AccountGetBuyerApplications(
    $breedTranslationsWhere: DogBreedTranslationWhereInput
    $orderBy: DogBreederApplicationOrderByWithRelationAndSearchRelevanceInput
    $where: DogBreederApplicationWhereInput
  ) {
    accountMe {
      id
      applications(where: $where, orderBy: $orderBy) {
        id
        createdAt
        status
        seenByBuyer

        breedPreference {
          id
          translations(where: $breedTranslationsWhere) {
            id
            name
          }
          imgs(take: 1, where: { type: { equals: COVER } }) {
            id
            small
          }
        }

        puppy {
          id
          dateOfBirth
        }

        dogBreeder {
          id
          profileImg

          account {
            id
            firstName
            lastName
          }

          breederBreeds {
            dogBreedId
          }
        }
      }
    }
  }
`);

export const useGetBuyerApplications = (archived: boolean) => {
  const { language } = useRouter();

  const { data, loading, refetch } = useQuery<
    AccountGetBuyerApplicationsQuery,
    AccountGetBuyerApplicationsQueryVariables
  >(ACCOUNT_GET_BUYER_APPLICATIONS, {
    variables: {
      breedTranslationsWhere: { language: { equals: language } },
      orderBy: {
        createdAt: SortOrder.desc,
      },
      where: {
        archived: { equals: archived },
        status: {
          in: [
            DogBreederApplicationStatus.CONTACT_AVAILABLE,
            DogBreederApplicationStatus.AWAITING_PAYMENT,
            DogBreederApplicationStatus.WAITING_LIST,
            DogBreederApplicationStatus.DONE,
          ],
        },
      },
    },
    ssr: false,
    fetchPolicy: 'no-cache',
  });

  return {
    applications: data?.accountMe?.applications ?? [],
    applicationsLoading: loading,
    applicationsRefetch: refetch,
  };
};
